export default __webpack_public_path__ + "static/media/advanced-anaytics-icon.96ca6c75.svg";